module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "layer-1-c0opy-1.02b9e61c.png";